var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTablerDeviceIpadCog = function SvgTablerDeviceIpadCog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-hidden": "true",
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium mui-msbgid",
    focusable: "false",
    style: {
      fill: "none"
    },
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10 17.5H5a1.667 1.667 0 0 1-1.667-1.667V4.167A1.667 1.667 0 0 1 5 2.5h10a1.667 1.667 0 0 1 1.667 1.667v5.416M7.5 15H10m5.834 2.5a1.666 1.666 0 1 1 0-3.333m0 3.333a1.667 1.667 0 0 0 0-3.333m0 3.333v1.25m0-4.583v-1.25m2.526 1.458L17.278 15m-2.886 1.667-1.084.625m0-2.917 1.084.625m2.886 1.667 1.083.625"
  })));
};
export default SvgTablerDeviceIpadCog;